module.exports = __webpack_public_path__ + "img/logo_gnp@2x.136821ee.png";